<template>
    <div class="product-add mt30">
        <!--form表单-->
        <div class="common-form">扩展字段</div>
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <el-form-item
                    v-for="(item, index) in form.values.fields"
                    :label="'字段' + (index + 1).toString()"
                    :key="item.key"
                    :prop="'values.fields.' + index + '.value'"
                    :rules="{required: true, message: '字段不能为空', trigger: 'blur'}"
            >
                <el-input v-model="item.value" style="width: 200px" ></el-input><el-button @click.prevent="removeField(item)">删除</el-button>
            </el-form-item>

            <el-form-item>
                <el-button @click="addField">新增字段</el-button>
            </el-form-item>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="primary" @click="onSubmit" :loading="loading" v-auth="'/education/setting/index'" >提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { getSetting, setSetting } from '@/api/education'
    import Upload from "@/components/file/Upload";

    export default {
        name: 'user-agreement-setting',
        components: {
            Upload
        },
        data() {
            return {
                /*form表单数据*/
                form: {
                    key: 'user_fields',
                    describe: '用户扩展字段',
                    values: {
                        fields: [{value: '', key: ''}],
                    }
                },
                /*是否正在加载*/
                loading: true,

            };
        },
        props: {

        },
        created() {
            this.getSet()
        },
        methods: {
            //提交表单
            onSubmit() {
                this.loading = true;
                setSetting(this.form)
                    .then(data => {
                        this.loading = false;
                        this.$message({
                            message: '恭喜你，设置成功',
                            type: 'success'
                        });

                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },
            removeField(item) {
                var index = this.form.values.fields.indexOf(item)
                if (index !== -1) {
                    this.form.values.fields.splice(index, 1)
                }
            },
            addField() {
                this.form.values.fields.push({
                    value: '',
                    key: Date.now()
                });
            },

            // 获取配置
            getSet(){
                getSetting({key: this.form.key}).then((result)=>{
                    if(result.data.values){
                        this.form.values = Object.assign(this.form.values, result.data.values)
                    }
                    this.loading = false;
                })
            },

            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.values.content = e
            },
        }
    };
</script>

<style>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/dept/setting/index.vue